import React, { useEffect, useState } from 'react';

export default function ApiClientItemRevokeSecretModal(props) {
    const [secretIsRevoked, setSecretIsRevoked] = useState(false);
    const [request, setRequest] = useState(false);
    const [requestFailed, setRequestFailed] = useState(false);

    useEffect(() => {
        $('#revoke-secret-modal').on('hidden.bs.modal', (e) => {
            internalCloseHandler();
        });
        return () => {
            $('#revoke-secret-modal').off('hidden.bs.modal');
        };
    }, []);

    const revokeSecret = () => {
        setRequest(true);
        const data = {
            secret_key: props.type,
        };

        axios
            .put(props.revokeSecretUrl, data)
            .then((res) => {
                setSecretIsRevoked(true);
            })
            .catch((e) => {
                setRequestFailed(true);
            })
            .finally(() => {
                setRequest(false);
            });
    };

    const cleanStates = () => {
        setRequest(false);
        setRequestFailed(false);
        setSecretIsRevoked(false);
    };

    const internalCloseHandler = () => {
        cleanStates();
        props.closeHandler();
    };

    const internalSuccessHandler = () => {
        cleanStates();
        props.successHandler();
    };

    return (
        <div className="modal fade" id="revoke-secret-modal" tabIndex="-1" role="dialog" aria-labelledby="revoke-secret-modal" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{$t('Revoke App Secret')}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={props.closeHandler}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    {!secretIsRevoked && !requestFailed && (
                        <>
                            <div className="modal-body">
                                <div className="tw-flex tw-flex-row">
                                    <label className="tw-basis-12/12">{$t('Are you sure you want to revoke App Secret?')}</label>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="button secondary" onClick={internalCloseHandler} disabled={request}>
                                    {$t('Cancel')}
                                </button>
                                <button type="button" className="button danger" onClick={revokeSecret} disabled={request}>
                                    {$t('Revoke')}
                                </button>
                            </div>
                        </>
                    )}
                    {secretIsRevoked && (
                        <div className="modal-body">
                            <div className="tw-flex tw-flex-row">
                                <label className="tw-basis-12/12">{$t('App secret successfully revoked')}</label>
                            </div>
                        </div>
                    )}
                    {requestFailed && (
                        <div className="modal-body">
                            <div className="tw-flex tw-flex-row">
                                <label className="tw-basis-12/12 tw-text-red-500">{$t('App secret could not be revoked')}</label>
                            </div>
                        </div>
                    )}
                    {(secretIsRevoked || requestFailed) && (
                        <div className="modal-footer">
                            <button type="button" className="button secondary" onClick={internalSuccessHandler}>
                                {$t('Close')}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
